import filter from 'lodash/filter';
import Api from '../api/axios';
import {
  GET_PRODUCT_DETAILS_PENDING,
  GET_PRODUCT_DETAILS_FULFILLED,
  GET_PRODUCT_DETAILS_FAILED,
  GET_SAMPLE_DETAILS_PENDING,
  GET_SAMPLE_DETAILS_FULFILLED,
  GET_SAMPLE_DETAILS_FAILED,
  UPDATE_PRODUCT_LINE_CONFIGURATION,
  UPDATE_COLOR_SWATCHES,
  TOGGLE_PLCC_MODAL,
} from './actionTypes';
import { getSurfaces } from './skuActions';
import { customProductPipLoaded } from '../utils/analytics/analyticsFunctions';
import { findTaggedValue } from '../utils/tags';
import { getFeatureGates } from '../utils/featureGates';

const updateColorSamplesInfo = (dispatch, getState, samples) => {
  const state = getState();
  const { currentColorSwatches, currentOmsId } = state.products;
  const colorSwatches = currentColorSwatches[currentOmsId] || [];
  const updatedColors = [];
  colorSwatches.forEach((cc) => {
    const sample = samples.find((xx) => xx.omsId === cc.sampleOmsId);
    if (sample) {
      updatedColors.push({ ...cc, sampleData: sample });
    }
  });

  dispatch({
    type: UPDATE_COLOR_SWATCHES,
    payload: (updatedColors.length && updatedColors) || colorSwatches,
  });
};

export const getSampleDetails = ({ id, storeId }) => (dispatch, getState) => {
  dispatch({
    type: GET_SAMPLE_DETAILS_PENDING,
  });

  const currentState = getState();

  return Api()
    .get(`${currentState?.config?.customBaseUrl}/countertops/api/samples/${storeId}/${id}`)
    .then((response) => {
      updateColorSamplesInfo(dispatch, getState, response.data.samples || []);
      dispatch({
        type: GET_SAMPLE_DETAILS_FULFILLED,
        payload: {
          response: response.data.samples,
        },
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_SAMPLE_DETAILS_FAILED,
        payload: {
          err,
        },
      });
    });
};

export const updateProductLineConfiguration = ({ productLine, configurations }) => ({
  type: UPDATE_PRODUCT_LINE_CONFIGURATION,
  payload: {
    productLine,
    configurations,
  },
});

export const getProductDetails = ({
  omsId, storeNumber, pageType, configSkuNumber, isPostFormLaminate
}) => (dispatch, getState) => {
  const isDraft = getFeatureGates()?.isDraft;

  dispatch({
    type: GET_PRODUCT_DETAILS_PENDING,
    payload: {
      omsId,
    },
  });

  let response = {};
  const currentState = getState();
  try {
    response = JSON.parse(currentState?.config?.productData);
    const colorSwatches = filter(response.ColorSwatches.map((ss) => ({
      id: ss.ChoiceId,
      name: ss.Name,
      imageUrl: `${currentState?.config?.eleanorBaseUrl}${ss.ImageUrl}`.replace(/\\/g, '/'),
      externalId: Number(findTaggedValue(ss.Tags, 'extid') || 0),
      sampleOmsId: Number(findTaggedValue(ss.Tags, 'sample') || 0),
      tags: ss.Tags,
      sampleData: null,
    })), (xx) => xx.externalId > 0);

    const extIds = currentState?.config?.attributes['external IDs (multiple)'];

    dispatch({
      type: GET_PRODUCT_DETAILS_FULFILLED,
      payload: {
        response,
        omsId,
        colorSwatches,
        productSurfaceCodes: extIds,
      },
    });
    const { ProductName: productName, Brand: brand } = response;
    dispatch(getSurfaces(storeNumber, extIds, configSkuNumber));

    // analytics
    try {
      if (pageType === 'PIP' && !isDraft) {
        customProductPipLoaded(
          omsId,
          productName,
          brand,
          currentState?.config?.omnitureInfo,
        );
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('Failed to send analytics on PIP load. ', error);
    }
  } catch (error) {
    dispatch({
      type: GET_PRODUCT_DETAILS_FAILED,
      payload: {
        error,
      },
    });
  }
};

export const togglePlccModal = (showModal) => ({
  type: TOGGLE_PLCC_MODAL,
  payload: {
    showModal
  }
});
